module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.error) ? _c('div', {
    staticClass: "sk-error-msg",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v("Connect your Amazon store")]), _vm._v(" "), _c('p', {
    staticClass: "sk-form-sub"
  }, [_vm._v("Approve SentryKit on Amazon. It takes about a minute.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-region-label",
    attrs: {
      "id": "connect-region-label"
    }
  }, [_vm._v("Where do you sell?")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-list",
    attrs: {
      "role": "radiogroup",
      "aria-labelledby": "connect-region-label"
    }
  }, _vm._l((_vm.regions), function(region) {
    return _c('div', {
      key: region.key,
      staticClass: "sk-region-row",
      class: {
        'is-selected': region.key === _vm.regionKey
      }
    }, [_c('label', {
      staticClass: "sk-region-radio"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "connect-region",
        "disabled": _vm.working
      },
      domProps: {
        "value": region.key,
        "checked": region.key === _vm.regionKey
      },
      on: {
        "change": function($event) {
          return _vm.selectRegion(region.key)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sk-region-name"
    }, [_vm._v(_vm._s(region.name))]), _vm._v(" "), _c('span', {
      staticClass: "sk-region-codes"
    }, [_vm._v(_vm._s(region.codes.join(', ')))])]), _vm._v(" "), (region.key === _vm.regionKey) ? _c('div', {
      staticClass: "sk-chip-row",
      attrs: {
        "role": "group",
        "aria-label": region.name + ' marketplaces'
      }
    }, [(region.codes.length > 1) ? _c('button', {
      staticClass: "sk-chip",
      class: {
        'is-on': _vm.allOn
      },
      attrs: {
        "type": "button",
        "aria-pressed": _vm.allOn ? 'true' : 'false',
        "disabled": _vm.working
      },
      on: {
        "click": _vm.onToggleAll
      }
    }, [_vm._v("All")]) : _vm._e(), _vm._v(" "), _vm._l((region.codes), function(code) {
      return _c('button', {
        key: code,
        staticClass: "sk-chip",
        class: {
          'is-on': _vm.selected.indexOf(code) !== -1,
          'is-locked': region.codes.length === 1
        },
        attrs: {
          "type": "button",
          "aria-pressed": _vm.selected.indexOf(code) !== -1 ? 'true' : 'false',
          "disabled": _vm.working || region.codes.length === 1
        },
        on: {
          "click": function($event) {
            return _vm.onToggleCode(code)
          }
        }
      }, [_vm._v(_vm._s(code))])
    })], 2) : _vm._e()])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "sk-region-note"
  }, [_vm._v("Selling in more than one region? Connect one now and add the others from Settings later.")]), _vm._v(" "), _c('button', {
    staticClass: "sk-btn sk-btn-primary sk-connect-submit",
    attrs: {
      "type": "button",
      "disabled": _vm.working || !_vm.canConnect
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.working ? 'Opening Amazon…' : _vm.buttonLabel))]), _vm._v(" "), _c('p', {
    staticClass: "sk-after-btn"
  }, [_vm._v("You'll sign in on Amazon's own page.")]), _vm._v(" "), (_vm.showTeammateLink) ? _c('p', {
    staticClass: "sk-teammate"
  }, [_vm._v("\n    Not the main Seller Central user?\n    "), _c('button', {
    staticClass: "sk-text-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.copying
    },
    on: {
      "click": function($event) {
        return _vm.$emit('copy-link')
      }
    }
  }, [_vm._v("Copy a link")]), _vm._v("\n    for your teammate and they can connect it.\n    "), (_vm.linkNote) ? _c('span', {
    staticClass: "sk-link-note"
  }, [_vm._v(_vm._s(_vm.linkNote))]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c7bdfe3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConnectRegionForm.vue
// module id = 756
// module chunks = 2